// extracted by mini-css-extract-plugin
export default {"wrap":"ModeratorVerifiedBadge_wrap__fWU8f","icon":"ModeratorVerifiedBadge_icon__6WIzd"};